import { Component, OnInit, Input } from '@angular/core';
import { GatemanService } from "../../services/gateman.service";
@Component({
  selector: 'app-badge-segment',
  templateUrl: './badge-segment.component.html',
  styleUrls: ['./badge-segment.component.scss'],
})
export class BadgeSegmentComponent implements OnInit {
  @Input() config: {
    class?: string,
    scroll: boolean,
    items: [{
      icon: string,
      title: Array<{"languageCode": string, "value": string}>,
      link: string
    }],
  };
  items:Array<any> = [];
  class: string = '';
  constructor(public gatemanService: GatemanService) { }

  ngOnInit() {
    //console.log("badge segment", this.config)
    if(this.config) {
      if(this.config.hasOwnProperty('items')) {
        this.items = this.config.items;
      }
      if(this.config.hasOwnProperty("class")) {
        this.class = this.config.class;
      }
    }

  }

}
